import moment from 'moment-timezone';
import store from '../store';

export const EVENT_REPEAT_TYPE = {
  NONE: 'none',
  DATES: 'dates',
  WEEKLY: 'week',
  MONTHLY: 'month',
  YEARLY: 'year',
};

export const CALENDAR_LIMIT = {
  MIN: 100001,
  MAX: 299912,
};

export const toWebCalEvent = calEvent => {
  const start = ymdHmNumToString(calEvent.startYmd, calEvent.startMin);
  const end = ymdHmNumToString(calEvent.endYmd, calEvent.endMin);
  return {
    start: start,
    end: end,
    startD: start,
    endD: end,
    allDay: calEvent.allDay,
    item: calEvent.event,
    uid: calEvent.uid,
  };
};

/**
 * change event to initial day calevent.
 */
export const toDefaultCalEvent = event => {
  // const firstDay = ymToDay1(ym);
  const repeat = event.repeat;

  const calEvents = [];
  if (!repeat || repeat.type == EVENT_REPEAT_TYPE.NONE) {
    if (event.all_day) {
      const d = event.d;
      if (!d) {
        console.debug(`invalid all day data eid ${event.id}. no d.s d.e.`);
        return null;
      }

      return toFirstCalEvent(event, Number(d.s.substring(0, 6)));
    } else {
      return toFirstCalEvent(event, Number(unixToTzMoment(event.start).format('YYYYMM')));
    }
  }

  if (repeat.type == EVENT_REPEAT_TYPE.DATES) {
    if (!event.dates) {
      console.warn([`invalid data eid dates ${event.id}`]);
      return null;
    }

    for (const d of Object.keys(event.dates)) {
      if (event.dates[d] != 1) continue;
      const r = toFirstCalEvent(event, Number(d.substring(1, 7)));
      if (r) return r;
    }
    return null;
  }

  if (!repeat.start) {
    console.warn([`invalid data eid repeat start time ${event.id}`]);
    return null;
  }

  if (event.repeat.type == EVENT_REPEAT_TYPE.WEEKLY) {
    let start = unixToTzMoment(repeat.start);
    for (let i = 0; i < 12; i++) {
      const r = toFirstCalEvent(event, Number(start.format('YYYYMM')));
      if (r) return r;
      start = start.add(1, 'month');
    }
    return null;
  }

  if (event.repeat.type == EVENT_REPEAT_TYPE.MONTHLY) {
    let start = unixToTzMoment(repeat.start);
    for (let i = 0; i < 12; i++) {
      const r = toFirstCalEvent(event, Number(start.format('YYYYMM')));
      if (r) return r;
      start = start.add(1, 'month');
    }
    return null;
  }

  if (event.repeat.type == EVENT_REPEAT_TYPE.YEARLY) {
    if (!repeat.md) {
      console.warn([`invalid data md eid ${event.id}`, repeat.md]);
      return null;
    }

    let start = unixToTzMoment(repeat.start);
    start = ymToDay1(Number(start.format('YYYY') + repeat.md.substring(1, 3)));
    for (let i = 0; i < 10; i++) {
      const r = toFirstCalEvent(event, Number(start.format('YYYYMM')));
      if (r) return r;
      start = start.add(1, 'year');
    }
    return null;
  }

  console.warn(`unknown repeat type eid ${event.id} repeat ${event.repeat.type}`);
  return null;
};

export const toFirstCalEvent = (event, ym) => {
  const calEvents = [];
  const firstDay = ymToDay1(ym);
  appendEventToCalEvent(calEvents, event, ym, firstDay);
  return calEvents.length > 0 ? calEvents[0] : null;
};

export const appendEventToCalEvent = (calEvents, event, ym, firstDay) => {
  const repeat = event.repeat;

  if (repeat.type == EVENT_REPEAT_TYPE.NONE) {
    let sm;
    let em;
    if (event.all_day) {
      const d = event.d;
      if (!d) {
        console.debug(`invalid all day data eid ${event.id}. no d.s d.e.`);
        return;
      }
      sm = moment.tz(`${d.s.substring(0, 4)}-${d.s.substring(4, 6)}-${d.s.substring(6, 8)}`, store.state.user.timezone);
      em = moment.tz(`${d.e.substring(0, 4)}-${d.e.substring(4, 6)}-${d.e.substring(6, 8)}`, store.state.user.timezone);
    } else {
      const momentTz = moment.tz(store.state.user.timezone);
      sm = unixToTzMoment(event.start);
      em = unixToTzMoment(event.end);
    }
    appendCalEvent(calEvents, event, firstDay, sm, em);
    return;
  }

  if (repeat.type == EVENT_REPEAT_TYPE.DATES) {
    if (!event.dates || (!repeat.duration && repeat.duration != 0)) {
      console.warn([`invalid data eid ${event.id}`, event.dates, repeat.duration]);
      return;
    }

    for (const d of Object.keys(event.dates)) {
      if (event.dates[d] != 1) return;
      if (event.all_day) {
        const sm = moment.tz(
          [Number(d.substring(1, 5)), Number(d.substring(5, 7)) - 1, Number(d.substring(7))],
          store.state.user.timezone
        );
        const em = repeat.duration == 0 ? moment(sm) : moment(sm).add(repeat.duration, 'd');
        appendCalEvent(calEvents, event, firstDay, sm, em);
      } else {
        const sm = moment.tz([Number(d.substring(1, 5)), Number(d.substring(5, 7)) - 1, Number(d.substring(7))], 'UTC');
        sm.add(event.repeat.startUtcMin, 'minutes').tz(store.state.user.timezone);
        const em = moment(sm).add(event.repeat.duration, 'minutes');
        appendCalEvent(calEvents, event, firstDay, sm, em);
      }
    }
    return;
  }

  if (event.repeat.type == EVENT_REPEAT_TYPE.WEEKLY) {
    if (!repeat.weeks || (!repeat.duration && repeat.duration != 0)) {
      console.warn([`invalid data eid ${event.id}`, repeat.weeks, repeat.duration]);
      return;
    }
    const fromTo = toRepeatFromTo(event, ym);
    if (!fromTo) return;

    // to midnight time
    const current = moment.tz(fromTo.from.format('YYYY-MM-DD') + ' 00:00:00.000', 'UTC');
    const warr = [0, 0, 0, 0, 0, 0, 0];
    for (const w of repeat.weeks) {
      warr[Number(w.substring(1))] = 1;
    }

    while (current.isSameOrBefore(fromTo.to)) {
      if (warr[current.weekday()]) {
        if (isDeleted(event, current)) {
          current.add(1, 'days');
          return;
        }

        if (event.all_day) {
          const s = moment(current);
          const e = moment(s).add(repeat.duration, 'days');
          if (checkRange(s, fromTo.repeatFrom, fromTo.repeatTo)) {
            appendCalEvent(calEvents, event, firstDay, s, e);
          }
        } else {
          const startMin = repeat.startUtcMin;
          const s = moment(current)
            .add(startMin, 'm')
            .tz(store.state.user.timezone);
          const e = moment(s).add(repeat.duration, 'm');
          if (checkRange(s, fromTo.repeatFrom, fromTo.repeatTo)) {
            appendCalEvent(calEvents, event, firstDay, s, e);
          }
        }
      }
      current.add(1, 'days');
    }
    return;
  }

  if (event.repeat.type == EVENT_REPEAT_TYPE.MONTHLY) {
    if (!repeat.d) {
      console.warn([`invalid data eid ${event.id}`, repeat.d]);
      return;
    }

    const fromTo = toRepeatFromTo(event, ym);
    if (!fromTo) return;

    const yms = [formatYyyyMm(ym - 1), ym, formatYyyyMm(ym + 1)];
    for (const curYm of yms) {
      let sm;
      let em;
      if (event.all_day) {
        sm = moment.tz(
          [Math.floor(curYm / 100), (curYm % 100) - 1, Number(repeat.d.substring(1))],
          store.state.user.timezone
        );
        if (isDeleted(event, sm)) return;
        em = repeat.duration == 0 ? moment(sm) : moment(sm).add(repeat.duration, 'd');
      } else {
        sm = moment.tz([Math.floor(curYm / 100), (curYm % 100) - 1, Number(repeat.d.substring(1))], 'UTC');
        if (isDeleted(event, sm)) return;
        sm.add(event.repeat.startAbsoluteMin, 'minutes').tz(store.state.user.timezone);
        em = moment(sm).add(event.repeat.duration, 'minutes');
      }
      if (
        sm.isBefore(fromTo.repeatFrom, event.all_day ? 'date' : 'minute') ||
        sm.isAfter(fromTo.repeatTo, event.all_day ? 'date' : 'minute')
      )
        return;
      appendCalEvent(calEvents, event, firstDay, sm, em);
    }
    return;
  }

  if (event.repeat.type == EVENT_REPEAT_TYPE.YEARLY) {
    if (!repeat.md) {
      console.warn([`invalid data eid ${event.id}`, repeat.md]);
      return;
    }

    const fromTo = toRepeatFromTo(event, ym);
    if (!fromTo) return;

    let sm;
    let em;
    if (event.all_day) {
      sm = moment.tz(
        [Math.floor(ym / 100), Number(repeat.md.substring(1, 3)) - 1, Number(repeat.md.substring(3))],
        store.state.user.timezone
      );
      if (isDeleted(event, sm)) return;
      em = repeat.duration == 0 ? moment(sm) : moment(sm).add(repeat.duration, 'd');
    } else {
      sm = moment.tz(
        [Math.floor(ym / 100), Number(repeat.md.substring(1, 3)) - 1, Number(repeat.md.substring(3))],
        'UTC'
      );
      if (isDeleted(event, sm)) return;
      sm.add(event.repeat.startAbsoluteMin, 'minutes').tz(store.state.user.timezone);
      em = moment(sm).add(event.repeat.duration, 'minutes');
    }
    if (
      sm.isBefore(fromTo.repeatFrom, event.all_day ? 'date' : 'minute') ||
      sm.isAfter(fromTo.repeatTo, event.all_day ? 'date' : 'minute')
    )
      return;
    appendCalEvent(calEvents, event, firstDay, sm, em);
    return;
  }

  console.warn(`unknown repeat type eid ${event.id} repeat ${event.repeat.type}`);
};

export const appendCalEvent = (calEvents, event, firstDay, s, e) => {
  calEvents.push(
    toCalEvent(
      event,
      Number(s.format('YYYYMMDD')),
      moment(s)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .diff(firstDay, 'days'),
      event.all_day ? 0 : Number(s.format('HHmm')),
      Number(e.format('YYYYMMDD')),
      moment(e)
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .diff(firstDay, 'days'),
      event.all_day ? 0 : Number(e.format('HHmm'))
    )
  );
};

export const toCalEvent = (event, startYmd, startIdx, startMin, endYmd, endIdx, endMin) => {
  return {
    uid: `d${startYmd}`,
    eid: event.id,
    event,
    name: event.title ? event.title.trim() : '',
    noName: !event.title || event.title.trim().length == 0,
    allDay: !!event.all_day,
    startYmd,
    startIdx,
    startMin,
    endYmd,
    endIdx,
    endMin,
    adjustedEndIdx: !event.all_day && startIdx != endIdx && !endMin ? endIdx - 1 : endIdx,
  };
};

export const ymToDay1 = (ym, tz) => {
  const m = ym % 100;
  return moment.tz(`${Math.floor(ym / 100)}-${m < 10 ? '0' + m : m}-01 00:00:00.000`, tz || store.state.user.timezone);
};

export const formatYyyyMm = yyyyMm => {
  if (yyyyMm < CALENDAR_LIMIT.MIN) return CALENDAR_LIMIT.MIN;
  if (yyyyMm > CALENDAR_LIMIT.MAX) return CALENDAR_LIMIT.MAX;
  const mm = yyyyMm % 100;
  const yyyy = Math.floor(yyyyMm / 100);
  const surplus = mm % 12;
  return (yyyy + Math.floor(mm / 12) + (surplus ? 0 : -1)) * 100 + (surplus || 12);
};

export const unixToTzMoment = unix => {
  return moment.unix(unix, store.state.user.timezone);
};

export const ymdHmNumToString = (ymd, hm) => {
  return `${Math.floor(ymd / 10000)}-${addZero(Math.floor(ymd / 100) & 100)}-${addZero(ymd % 100)} ${addZero(
    Math.floor(hm / 100)
  )}:${addZero(hm % 100)}`;
};

const addZero = v => {
  return v < 10 ? `0${v}` : v;
};

export default {
  toWebCalEvent,
  toDefaultCalEvent,
  appendEventToCalEvent,
};
